import React, { useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import CustomInput from '../../../CustomComponents/FormInputs';
import { useTranslation } from 'react-i18next';
import { displayErrorMessage, displayKudzuplusErrorMessage } from '../../../../utils';
import TimerIcon from '../../../../assets/images/timer.png';
import logFirebaseEvents from '../../../LogFirebaseEvents';
import { appTheme } from '../../../../helpers/utils/Utils';
import { useSelector } from 'react-redux';
const schema = yup.object().shape({
    verifyCode: yup
        .string()
        .required('otp_required')
        .matches(/^\d{6}$/, ('otp_required')),
});

const VerifyEmailCode = ({ CloseModalOnVerify, onCreatePasswordClick, errorMesssage, onClickEmailVerifyTryAgain, clearError, verifyRef }) => {
    const { t } = useTranslation();
    const kudzuPlusTrue =  useSelector(state => state.kudzuPlusTrue);
    const isFromSmiOne = useSelector((state) => state.fromSmiOne);
    const [modalVisible, setModalVisible] = useState(false);
    const [emailOtp, setemailOtp] = useState('');
    const [validOTP, setValidOTP] = useState(false);
    const [isValid, setvalidCode] = useState(false);
    const [verifyCode, setCode] = useState(''); // State variable to store the input value
    const [message, setMessage] = useState('');
    const inputRef = useRef(null);
    const submitButtonRef = useRef(null);
    const appThemeData = appTheme(kudzuPlusTrue)

    useEffect(() => {
        if (verifyCode.length === 6 && submitButtonRef.current) {
            //     // Focus on the submit button when 6 digits are entered
            submitButtonRef.current.focus();
        }

    }, [verifyCode])

    useEffect(() => {
        if (errorMesssage) {
          setMessage(errorMesssage);
        }
      }, [errorMesssage]);      

    const {
        register,
        formState: { errors },
        setError,
        clearErrors,
    } = useForm({
        resolver: yupResolver(schema),
    });

    const handleVerifyCodeChange = async (event) => {
        clearErrors(true);
        setMessage('');
        clearErrors('verifyCode');
        const { name, value } = event.target;
        setCode(value);
        setvalidCode(false);
        try {
            await schema.validate({ [name]: value });
            setvalidCode(true);
            setCode(value);
            setMessage('');
            clearErrors('verifyCode');
        } catch (error) {
            const errorMessage = value.length === 0 ? t('otp_required') : t('Invalid_Verification_Code');
            setError('verifyCode', { type: 'manual', message: errorMessage });
            setMessage(errorMessage);
            setvalidCode(false);
        }
    };

    const verifyEmailOtpCode = () => {
        if (verifyCode.length === 6 && isValid) {
            logFirebaseEvents("OTP_Screen", "verify_Email_OTP_Clicked", "verify_Email_OTP_Clicked", "","");
            onCreatePasswordClick(verifyCode);
        } else {
            if (verifyCode.length === 0) {
                setMessage(t('otp_required'));
            } else {
                setMessage(t('Invalid_Verification_Code'));
            }
        }
    };

    useEffect(() => {
        if (verifyRef) {
            verifyRef.current = verifyEmailOtpCode;
        }
    }, [verifyCode, isValid]);

    return (
        <>
            

            <div className={`flex flex-col ${isFromSmiOne ? 'w-[75%]' : 'w-full'}  h-246`}>
                <div className="flex flex-col">
                        <CustomInput
                            name="verifyCode"
                            value={verifyCode}
                            label={t('verification_code_label')}
                            placeholder={t("verification_code_placeholder")}
                            register={register}
                            error={message ? { message } : errors.verifyCode}
                            type="otp"
                            onChange={handleVerifyCodeChange}
                            isValid={isValid}
                            autoFocus={true}
                            required={true} 
                            ref={inputRef}
                            showValidity={true}
                        />
                </div>
            </div>
            {message &&
                <div className='mb-2'>
                    {/* {displayErrorMessage(message)} */}
                    {kudzuPlusTrue? displayKudzuplusErrorMessage(message) :displayErrorMessage(message)}

                </div>
               
            }
            <div className=" flex flex-row gap-3 items-center md:mb-6 sm:mb-12 mb-28">
                <span className=" text-secondary">
                    <img src={TimerIcon} className="lg:w-[20px] lg:h-[20px] md:w-[17px] md:h-[17px] sm:w-[14px] sm:h-[14px] w-[14px] h-[14px]" alt="" />
                </span>
                <p className="font-hanken-grotesk lg:text-md md:text-[14px] sm:text-[12px] text-[14px] leading-7 text-[var(--modal-text-heading-clr)] font-medium">
                    {t("security_check_notification")}
                </p>
            </div>
            <p className="font-hanken-grotesk  md:text-[18px] sm:text-[12px] text-[16px]  leading-7 text-[var(--modal-text-heading-clr)] font-medium">
                {t("didnt_recieve_email")}{" "}
                <button
                    type="button"
                    className="font-hanken-grotesk font-semibold sm:text-[14px] text-[16px] md:text-md text-[#2965FB]  cursor-pointer"
                    onClick={onClickEmailVerifyTryAgain}>
                    {t("try_again")}<span className="dot"></span>
                </button> 

            </p>
        </>
    );
};

export default VerifyEmailCode;
